import React from 'react';
import { Table } from 'semantic-ui-react';
import parse from 'html-react-parser';


const GiganetUpdatesTable = ({ updates }) => {
  const updatesKey = Object.keys(updates)[0];
  const specificUpdates = updates[updatesKey];

  if (!specificUpdates || specificUpdates.length === 0) {
    return null;
  }

  // Function to format the date to dd/mm/yyyy
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatComment = (comment) => {
    const replaceNewLines = comment.replace(/\n/g, '<br>');
    const decodedHtml = replaceNewLines
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");

    return parse(decodedHtml);
  };
  


  return (
    <Table celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Date Issued</Table.HeaderCell>
          <Table.HeaderCell>State</Table.HeaderCell>
          <Table.HeaderCell>Message</Table.HeaderCell>
          {/* Add other header cells as needed */}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {specificUpdates.map((update, index) => (
          <Table.Row key={index}>
            <Table.Cell>{formatDate(update.status_timestamp)}</Table.Cell>
            <Table.Cell>{update.state}</Table.Cell>
            <Table.Cell>{formatComment(update.comment)}</Table.Cell>
            {/* Add other cells as needed */}
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default GiganetUpdatesTable;
